import React from "react";
import { useGetLabels } from "../../../../../hooks/useGetLabels";
import { CommonFieldBankController } from "../../components/common/commonFieldBankController";
import { patientFields } from "./form/fieldNames";
import { SelectItem, CheckboxItem } from "../../components/form";
import { relationshipToPatientObjects } from "../freeDrug/genentechPapFieldsConfiguration";

const genentechCopayi18nRoutes = {
  patient: "application_form_editor.genentech.free_drug.patient.labels"
};

export const getGenentechCopaySpecificSections = () => {
  const { getLabelsBySection } = useGetLabels(genentechCopayi18nRoutes);
  const patientLabels = getLabelsBySection("patient");
  const commonFields = CommonFieldBankController();

  return {
    patient: {
      ...commonFields.common,
      ...commonFields.patient,
      patient_divider: () =>
        commonFields.common.divider({
          id: "application-form-patient-divider",
          text: "Legal Authorized Person (LAP) Information"
        }),
      relationship_to_patient: ({ required }) => (
        <SelectItem
          name={patientFields.relatedPersonRelationship}
          rules={[{ required }]}
          label={patientLabels.relationToPatient}
          placeholder={patientLabels.relationToPatientPlaceholder}
          optionItems={relationshipToPatientObjects}
          style={{ width: "100%" }}
          bordered={true}
          useCommonStyle={false}
          key="relationship_to_patient-genentech-copay"
        />
      ),
      related_firstName: ({ required }) =>
        commonFields.common.firstName({
          required,
          name: patientFields.relatedPersonFirstName,
          label: patientLabels.firstName,
          placeholder: patientLabels.firstNamePlaceholder,
          key: "related-firstName-genentech-copay"
        }),
      related_lastName: ({ required }) =>
        commonFields.common.lastName({
          required,
          name: patientFields.relatedPersonLastName,
          label: patientLabels.lastName,
          placeholder: patientLabels.lastNamePlaceholder,
          key: "related-lastName-genentech-copay"
        }),
      related_dob: ({ required }) =>
        commonFields.patient.dob({
          required,
          name: patientFields.relatedPersonDob,
          label: patientLabels.dob,
          key: "related-dob-genentech-copay"
        }),
      related_phone_number: ({ required }) =>
        commonFields.common.phone_number({
          required,
          name: patientFields.relatedPersonPhone,
          label: patientLabels.phoneNumber,
          placeholder: patientLabels.phoneNumberPlaceholder,
          typeName: patientFields.relatedPersonPhoneType,
          style: { display: "flex" },
          key: "related-phone-number-genentech-copay"
        }),
      related_additional_phone_number: ({ required }) =>
        commonFields.patient.additional_phone_number({
          required,
          name: patientFields.relatedPersonAdditionalPhone,
          label: patientLabels.additionalPhoneNumber,
          placeholder: patientLabels.additionalPhoneNumberPlaceholder,
          typeName: patientFields.relatedPersonAdditionalPhoneType,
          style: { display: "flex" },
          key: "related-additional-phone-number-genentech-copay"
        }),
      related_address: ({ required }) =>
        commonFields.common.address({
          required,
          name: patientFields.relatedPersonAddress,
          label: patientLabels.address,
          placeholder: patientLabels.addressPlaceholder,
          key: "related-address-genentech-copay"
        }),
      related_city: ({ required }) =>
        commonFields.common.city({
          required,
          name: patientFields.relatedPersonCity,
          label: patientLabels.city,
          placeholder: patientLabels.cityPlaceholder,
          key: "related-city-genentech-copay"
        }),
      related_state: ({ required }) =>
        commonFields.common.state({
          required,
          name: patientFields.relatedPersonState,
          label: patientLabels.state,
          placeholder: patientLabels.statePlaceholder,
          key: "related-state-genentech-copay"
        }),
      related_zip: ({ required }) =>
        commonFields.common.zip_code({
          required,
          name: patientFields.relatedPersonZip,
          label: patientLabels.zipCode,
          placeholder: patientLabels.zipCodePlaceholder,
          key: "related-zip-genentech-copay"
        }),
      signed_patient_authorization: ({ required }) => (
        <CheckboxItem
          name={patientFields.relatedPersonSignedAuthorization}
          label="Signed Patient Authorization"
          required={required}
          key="signed-patient-authorization-genentech-copay"
        />
      )
    }
  };
};
